import React from 'react';
import { Box, Button, makeStyles } from '@material-ui/core';
import { Payment } from '@material-ui/icons';
import { useListContext, useTranslate } from 'react-admin';
import MakePaymentButton from '../MakePaymentButton';
import resourceSlug from '../../../../constant/resource-slug';
import { useGetNoPageListData } from '../../../../base/components/customized/CustomizedNoPageList';
import { useInvoiceIdsSync } from '../../hooks';

const InvoiceBulkActionButtons = ({ selectedIds = [] }) => {
  const t = useTranslate();
  const classes = useStyles();

  const { refetchListData } = useGetNoPageListData(resourceSlug.INVOICE);

  const { setInvoiceIds } = useInvoiceIdsSync();

  const { onUnselectItems } = useListContext();

  return (
    <>
      <MakePaymentButton
        invoiceIds={selectedIds}
        onPayment={() => setInvoiceIds(selectedIds)}
        onSuccess={() => {
          refetchListData();
          onUnselectItems();
        }}
        trigger={
          <Button color="primary" variant="text" size="small" startIcon={<Payment />} className={classes.paymentButton}>
            <Box fontSize={12}>{t('resources.invoice.makePayment')}</Box>
          </Button>
        }
      />
    </>
  );
};

export default InvoiceBulkActionButtons;

const useStyles = makeStyles((theme) => ({
  paymentButton: {
    background: theme.palette.primary.main,
    color: 'white',
    '&:hover': {
      background: theme.palette.primary.dark,
    },
  },
}));
